import { render, staticRenderFns } from "./i-zinvoiceOLD.vue?vue&type=template&id=2bae2c71&"
import script from "./i-zinvoiceOLD.vue?vue&type=script&lang=js&"
export * from "./i-zinvoiceOLD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports